import React from 'react';

const InputTextBox = ({ errors, multiple, accept, placeholder, id, onInput,  inputRef, max, label, type, name, onKeyPress, onClick,onDoubleClick,
  title,
  value,
  handleChange,
  handleBlur,
  focus,
  touched,
  inputProps,
  required,
  disabled,
}) => {
  const defaultOnInput = onInput || (() => {});

  return (
    <div className="relative">
      {label ? <div className='flex flex-row'><label className="block text-[12px] font-medium text-gray700 dark:text-gray-200 mb-1 font-sans" htmlFor={name}>{label}</label>{required ? <span className='text-red-500 pl-2'>*</span>:""}</div> : ""}
      <div className=''></div>
      <input
      id={id||name}
        type={type || "text"}
        onKeyPress={onKeyPress}
        onClick={onClick}
        placeholder={placeholder || ""}
        name={name}
        title={title}
        value={value} 
        className={`w-full px-3 py-1 text-[13px] font-sans rounded-sm border border-gray400 transition-all outline-none duration-150 placeholder:text-[11.5px] placeholder:text-gray-400 placeholder:select-none
          bg-white dark:bg-slate-800 text-gray-800 dark:text-gray-100
          ${errors ? "border-red-500 focus:ring-2 focus:ring-red-500/40 focus:border-red-500" : "border-gray-300 dark:border-slate-600 focus:ring-[1px] focus:ring-customPrimary/70 focus:border-customPrimary"}
          ${disabled ? "bg-gray-100 dark:bg-slate-700 text-gray-400 dark:text-gray-500 cursor-not-allowed border-gray-200 dark:border-slate-600" : "hover:border-gray-400 dark:hover:border-slate-500"}
          focus:outline-none`}
        required={required}
        autoComplete="off"
        autoCorrect='off'
        multiple={multiple||""}
        focus={focus}
        onDoubleClick={onDoubleClick}
        ref={inputRef}
        inputProps={inputProps}
        touched={touched ? "true" : ""}
        disabled={disabled || false}
        onWheel={(e) => e.preventDefault()}
        onBlur={handleBlur}
        onChange={handleChange}
        onInput={onInput||defaultOnInput}
        max={max||""}
        accept={accept ||""}
      />
      {errors && <div className='text-red-500 text-[12px] mt-0.5 font-sans'>{errors}</div>}
    </div>
  )
}

export default InputTextBox